import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useGetRole from '../../../../API/hooks/useGetRole';
import S from './WithUnassignStyles';
import Modal from '../../Modal/Modal';
import DeleteModal from '../../DeleteModal/DeleteModal';
import ImageWithFallback from '../../ImageWithFallback/ImageWithFallback';

type Props = {
  title: string;
  description: string;
  imageSrc: string;
  apiCall: any;
  link?: string;
  mutationConfig: Record<string, string | null>;
};

function WithUnassign({
  title, description, imageSrc, apiCall, link, mutationConfig,
}: Props): JSX.Element {
  const navigate = useNavigate();
  const { isFleetViewer } = useGetRole();
  const [confirmModalOpen, toggleConfirmModalOpen] = useState(false);
  const [unassignError, setUnassignError] = useState('');
  const [unassignSuccess, setUnassignSuccess] = useState(false);
  const onSubmitSuccess = (): void => {
    setUnassignError('');
    setUnassignSuccess(true);
  };
  const onSubmitFail = (error: string): void => {
    setUnassignError(error);
  };

  const { mutate, isLoading } = apiCall(onSubmitSuccess, onSubmitFail);

  const handleUnassign = (): void => mutate(mutationConfig);

  const confirmUnassign = (): void => toggleConfirmModalOpen(true);

  const onClick = (): void => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <>
      <S.Wrapper isDisabled={unassignSuccess}>
        <button className="entity-preview" onClick={onClick} type="button">
          <div className="avatar">
            <ImageWithFallback src={imageSrc} alt="vehicle" />
          </div>
          <div className="description">
            <p className="title" title={title}>{title}</p>
            <p className="subtitle" title={description}>{description}</p>
          </div>
        </button>
        {!isFleetViewer && (
          <button
            type="button"
            className="unassign-btn"
            onClick={confirmUnassign}
            disabled={unassignSuccess}
          >
            {isLoading ? 'Loading...' : 'Unassign'}
          </button>
        )}
      </S.Wrapper>
      {confirmModalOpen && (
        <Modal
          title="Confirm unassign"
          state={confirmModalOpen}
          toggleState={toggleConfirmModalOpen}
          settings={{
            minWidth: '500px',
          }}
        >
          <DeleteModal
            title={`Are you sure you want to unassign ${title || ''}?`}
            onClose={() => toggleConfirmModalOpen(false)}
            onDelete={handleUnassign}
            btnConfirmText="Confirm"
          />
        </Modal>
      )}
    </>
  );
}

export default WithUnassign;
